import { Empty, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type DocumentTemplate } from "../../types/types.ts"
import { DocumentTemplatesListItem } from "./DocumentTemplatesListItem.tsx"

const { Text } = Typography

interface DocumentTemplatesListProps {
  templates: DocumentTemplate[]
  hasSearch?: boolean
  //
  copyAllowed?: boolean
  deleteAllowed?: boolean
  editAllowed?: boolean
  //
  onDelete?: (id: string) => void
  onPreview?: (id: string) => void
  onDuplicate?: (id: string) => void
}

export function DocumentTemplatesList({
  templates,
  hasSearch,
  copyAllowed,
  deleteAllowed,
  editAllowed,
  onDelete,
  onDuplicate,
  onPreview
}: DocumentTemplatesListProps) {
  const { t } = useTranslation()

  if (!templates?.length) {
    return (
      <Empty
        className="py-8"
        description={
          hasSearch ? (
            <Flex vertical className="text-center py-3">
              <Text type="secondary" strong>
                {t("documentTemplates.empty.noMatches")}
              </Text>
              <Text type="secondary" className="mt-1">
                {t("documentTemplates.empty.tryOtherKeywords")}
              </Text>
            </Flex>
          ) : (
            t("documentTemplates.empty.none")
          )
        }
      />
    )
  }

  return (
    <>
      {templates.map((template) => (
        <DocumentTemplatesListItem
          key={template?.id}
          template={template}
          copyAllowed={copyAllowed}
          deleteAllowed={deleteAllowed}
          editAllowed={editAllowed}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
          onPreview={onPreview}
        />
      ))}
    </>
  )
}
